import React, { useState, useEffect, useRef, useMemo } from "react";
import StyleRenderer from "../StyleRenderer";
import PlaylistVideoPlayer from "../PlaylistVideoPlayer";
// import PlaylistVideoPlayer from "./PlaylistVideoPlayer";
// import StyleRenderer from "./StyleRenderer";

const PlaylistSimple = ({ attributes, nonce }) => {
  const { videos, styles, options, uniqueId } = attributes;
  const [currentVideo, setCurrentVideo] = useState(videos?.[0] || {});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [player, setPlayer] = useState(null);
  const ref = useRef();

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        // ref.current.querySelector(".video__right").style.height = ref.current.querySelector(".video__left .video__main").offsetHeight + "px";
      }
    }, 100);
  }, [currentVideo]);

  useEffect(() => {
    if (player && options.autoplayNextVideo) {
      player.on("ended", () => {
        const currentVideo = document.querySelector(`.item-active`);
        // window.currentVideo = currentVideo;
        const nextIndex = currentVideo.nextElementSibling?.dataset?.index || 0;
        // console.log({ nextIndex });
        if (nextIndex) {
          setCurrentIndex(nextIndex);
        }
      });
    }
  }, [player]);

  useEffect(() => {
    window.currentIndex = currentIndex;
    setCurrentVideo(videos[currentIndex] || videos[0]);
    document.querySelectorAll(`.item-active`).forEach((item) => {
      item.classList.remove("item-active");
    });
    document.querySelector(`.video-item[data-index="${currentIndex}"]`)?.classList.add("item-active");
    console.log({ currentIndex });
  }, [currentIndex]);

  return (
    <div id={uniqueId} className={`video video--bg simplelist`} ref={ref}>
      <StyleRenderer styles={styles} uniqueId={uniqueId} />
      <div className="h5vp_playlist_container">
        <div className="video__top video__wrapper">
          <PlaylistVideoPlayer video={currentVideo} options={options} player={player} setPlayer={setPlayer} />
        </div>
        <div className="video__top">
          {videos.map((video, index) => (
            <>
              <li
                key={index}
                className={`video-item video-item-${index} ${currentIndex === index ? "item-active" : ""}`}
                onClick={() => {
                  setCurrentVideo(video);
                  setCurrentIndex(index);
                }}
                data-index={index}
              >
                <a href="#" className="h5vp_playlist_item" data-provider={video.h5vp_video_provider} data-poster={video.video_thumb} data-videoindex="0" data-source={video.h5vp_video_source}>
                  <div className="overlay"></div>
                  <div className="noImage"></div>
                  <div className="svg">
                    {currentIndex === index ? (
                      <svg aria-hidden="true" focusable="false">
                        <use xlinkHref="#plyr-pause"></use>
                      </svg>
                    ) : (
                      <svg aria-hidden="true" focusable="false">
                        <use xlinkHref="#plyr-play"></use>
                      </svg>
                    )}
                  </div>
                  <video src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4" style={{ display: "none" }}></video>
                </a>
                <div className="video_title">
                  <h3 className="title">{video.video_title}</h3>
                </div>
              </li>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlaylistSimple;
